




































































































































































































































































































































import { getFlagEmoji } from "@/lib/CountryCodeHelper";
import { formatCurrency } from "@/lib/utility/currency-helper";
import { simpleDate } from "@/lib/utility/date-helper";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import RulesMixin from "@/mixins/RulesMixin.vue";
import { ICompany } from "@/models/company.entity";
import { InvoiceLine } from "@/models/invoice-line.entity";
import { DocumentDirectionEnum, IInvoice, InvoiceTypeEnum } from "@/models/invoice.entity";
import { CoverageTypeEnum } from "@/store/enum/coverage-type.enum";
import { PartnerModule } from "@/store/modules/partner";
import { mixins } from "vue-class-component";
import { Component, Prop, Ref, Watch } from "vue-property-decorator";
import CompanySelection from "../partner/report/v2/contact/CompanySelection.vue";
import Debug from "../utility/Debug.vue";
import Tooltip from "../utility/tooltip.vue";
import InvoiceFormLinesTableRow from "./InvoiceFormLinesTableRow.vue";
import InvoicePartyForm from "./InvoicePartyForm.vue";

@Component({
  components: {
    InvoiceFormLinesTableRow,
    InvoicePartyForm,
    CompanySelection,
    Tooltip,
    Debug
  },
  filters: {
    getFlagEmoji
  }
})
export default class InvoiceFormPreview extends mixins(PermissionMixin, RulesMixin) {
  readonly formatCurrency = formatCurrency;
  readonly InvoiceLine = InvoiceLine;
  readonly DocumentDirectionEnum = DocumentDirectionEnum;
  readonly InvoiceTypeEnum = InvoiceTypeEnum;

  buyerCompany: ICompany | null = null;
  sellerCompany: ICompany | null = null;
  isBuyerLoading = false;

  @Ref("sellerForm") sellerForm!: InvoicePartyForm;
  @Ref("buyerForm") buyerForm!: InvoicePartyForm;

  @Prop()
  value!: IInvoice;

  @Prop({ default: false })
  readonly!: boolean;

  @Prop()
  coverageType?: CoverageTypeEnum;

  @Watch("sellerCompany")
  onSellerCompanyChange() {
    this.$log.debug(this.sellerCompany);

    if (this.sellerCompany) {
      this.value.seller = this.sellerCompany.invoiceParty;
      this.value.sellerCompany = this.sellerCompany;
    }
  }

  @Watch("buyerCompany")
  async onBuyerCompanyChange() {
    this.$log.debug(this.buyerCompany);

    if (!this.buyerCompany) {
      return;
    }

    this.isBuyerLoading = true;
    await this.buyerCompany.fetch().finally(() => (this.isBuyerLoading = false));

    this.value.buyer = this.buyerCompany.invoiceParty;
    this.value.buyerCompany = this.buyerCompany;

    if (!this.buyerCompany.billingProfile) {
      return;
    }

    const due = new Date();

    due.setDate(due.getDate() + this.buyerCompany.billingProfile.paymentTerm);

    this.value.dueFormable = due.toISOString();

    this.value.buyer.email = this.buyerCompany.billingProfile.email ?? this.buyerCompany.contact?.email;
    this.value.header = this.buyerCompany.billingProfile.invoiceSubjectLine ?? undefined;

    if (!this.value.notes) {
      this.value.notes = [];
    }

    if (this.buyerCompany?.billingProfile?.purchaseOrderNumber) {
      this.value.notes?.push(
        `${this.$t("objects.contract.customer.purchaseOrderNumber").toString()}: ${
          this.buyerCompany.billingProfile.purchaseOrderNumber
        }`
      );
    }

    if (this.buyerCompany?.billingProfile?.note) {
      this.value.notes?.push(this.buyerCompany.billingProfile.note);
    }
  }

  get sepaAccount() {
    return this.value.buyerCompany?.bankings?.find(b => b.isSepaDirectDebitMandate) ?? null;
  }

  get taxRates() {
    return this.value.taxRates;
  }

  get invoiceTypes() {
    return [InvoiceTypeEnum.COMMERCIAL, InvoiceTypeEnum.CREDIT_NOTE];
  }

  get partner() {
    return PartnerModule.partner;
  }

  get footerDefault() {
    const sepa = this.value.buyerCompany?.bankings?.find(b => b.isSepaDirectDebitMandate);
    if (sepa) {
      return this.$t("objects.invoice.footerSepa", {
        sepaCreditorId: this.partner.settings?.sepaCreditorId,
        sepaDirectDebitMandateNumber: sepa.sepaDirectDebitMandateNumber,
        iban: sepa.iban,
        bank: sepa.bank,
        bic: sepa.bic,
        total: formatCurrency(this.value.totalGross, this.value.currency),
        due: simpleDate(this.value.due ?? new Date().toISOString())
      }).toString();
    } else {
      return this.$t("objects.invoice.footerDefault", {
        total: formatCurrency(this.value.totalGross, this.value.currency),
        due: simpleDate(this.value.due ?? new Date().toISOString())
      }).toString();
    }
  }

  get footerCreditNote() {
    return this.$t("objects.invoice.footerCreditNote", {
      total: formatCurrency(this.value.totalGross, this.value.currency)
    }).toString();
  }

  addInvoiceLine() {
    this.value.lineItems.push(new InvoiceLine());
  }

  removeInvoiceLine(index: number) {
    this.value.lineItems.splice(index, 1);
  }

  addNoteEntry(note = "") {
    if (!this.value.notes) {
      this.value.notes = [];
    }
    this.value.notes.push(note);
  }

  removeNoteEntry(index: number) {
    if (!this.value.notes) {
      return;
    }

    this.value.notes.splice(index, 1);
  }
}
